import { assertNever } from "helpers/Helpers";
import { Stage } from "./Stages";

export enum StepId {
    VehicleLookup,
    OdometerReading,
    RequiredWork,
    ServiceCentreSearch,
    ChooseDateAndTime,
    DriverDetails,
    Summary,
    BookingConfirmation,
}

export type Step = {
    id: StepId;
};

export const initialStep = StepId.VehicleLookup;

export const getStage = (stepId: StepId): Stage | null => {
    switch (stepId) {
        case StepId.VehicleLookup:
            return Stage.VehicleInfo;
        case StepId.OdometerReading:
            return Stage.VehicleInfo;
        case StepId.RequiredWork:
            return Stage.RequiredWork;
        case StepId.ServiceCentreSearch:
            return Stage.FindAGarage;
        case StepId.ChooseDateAndTime:
            return Stage.TimeAndDate;
        case StepId.DriverDetails:
            return Stage.DriverDetails;
        case StepId.Summary:
            return Stage.Summary;
        case StepId.BookingConfirmation:
            return null;
        default:
            assertNever(stepId);
    }
};

export const getFirstStepOfStage = (stage: Stage): StepId => {
    switch (stage) {
        case Stage.VehicleInfo:
            return StepId.VehicleLookup;
        case Stage.RequiredWork:
            return StepId.RequiredWork;
        case Stage.FindAGarage:
            return StepId.ServiceCentreSearch;
        case Stage.TimeAndDate:
            return StepId.ChooseDateAndTime;
        case Stage.DriverDetails:
            return StepId.DriverDetails;
        case Stage.Summary:
            return StepId.Summary;
        default:
            assertNever(stage);
    }
};

const stepsOrder: StepId[] = [
    StepId.VehicleLookup,
    StepId.OdometerReading,
    StepId.RequiredWork,
    StepId.ServiceCentreSearch,
    StepId.ChooseDateAndTime,
    StepId.DriverDetails,
    StepId.Summary,
    StepId.BookingConfirmation,
];

export const getPreviousStep = (stepId: StepId): StepId | null => {
    const currentStepIndex = stepsOrder.indexOf(stepId);
    return stepsOrder[currentStepIndex - 1] ?? null;
};

export const getNextStep = (stepId: StepId): StepId | null => {
    const currentStepIndex = stepsOrder.indexOf(stepId);
    return stepsOrder[currentStepIndex + 1] ?? null;
};
